import { extractLastNameComponent } from '@spotify/confidence-core-react';
import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import { createWorkflowUpdatesChangeExtension } from '@spotify/plugin-confidence-workflows-react';

import { RolloutData } from '../../types';

const getDisplayName = (resourcePath: string | undefined): string => {
  if (!resourcePath) return '';
  return extractLastNameComponent(resourcePath) || resourcePath;
};

type ChangeType = {
  variantChanged: boolean;
  oldVariant: string | undefined;
  newVariant: string | undefined;
};

const analyzeChange = (
  oldValue: RolloutData | null,
  newValue: RolloutData | null,
): ChangeType => {
  return {
    variantChanged: oldValue?.variant !== newValue?.variant,
    oldVariant: oldValue?.variant,
    newVariant: newValue?.variant,
  };
};

const FlagVariantChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as RolloutData | null;
  const newValue = change.newValue as RolloutData | null;

  const { oldVariant, newVariant } = analyzeChange(oldValue, newValue);

  const label = oldVariant ? 'Changed treatment' : 'Added treatment';

  return (
    <ActivityItem.Section label={label}>
      <ActivityTagItem
        newValue={getDisplayName(newVariant)}
        oldValue={oldVariant ? getDisplayName(oldVariant) : undefined}
        ariaLabel="Treatment name"
      />
    </ActivityItem.Section>
  );
};

export const FLAG_VARIANT_CHANGE_EXTENSION =
  createWorkflowUpdatesChangeExtension({
    id: 'rollout-flag-variant-change',
    predicate: ({ change }) => {
      if (change.fieldPath !== '/module_data/rollout') {
        return false;
      }
      const oldValue = change.oldValue as RolloutData | null;
      const newValue = change.newValue as RolloutData | null;
      const { variantChanged } = analyzeChange(oldValue, newValue);
      return variantChanged;
    },
    render: FlagVariantChangeRender,
  });
